// src/components/InspectionHubLevage.js - VERSION CORRIGÉE

import React, { useState, useEffect } from 'react';
import './InspectionHub.css';
import inspectionStorage from '../services/inspectionStorage';
import apiService from '../services/apiService';
import cloneManager from '../services/cloneManager';  // ✅ AJOUTÉ
import { useRapportMeta } from '../hooks/useRapportMeta';

import Etape1InfosLevageMobile from './Etape1InfosLevageMobile';
import Etape2CaracteristiquesMobile from './Etape2CaracteristiquesMobile';
import Etape3PhotosMachineMobile from './Etape3PhotosMachineMobile';
import Etape4PointsControleMobile from './Etape4PointsControleMobile';
import Etape5DocumentationEssaisMobile from './Etape5DocumentationEssaisMobile';
import Etape5ObservationsLevageMobile from './Etape5ObservationsLevageMobile';
import Etape6FinalisationLevageMobile from './Etape6FinalisationLevageMobile';

function InspectionHubLevage({ mission, onBack, onGoHome }) {
  const [progress, setProgress] = useState({ completed: 0, total: 6, percentage: 0 });
  const [unsyncedChanges, setUnsyncedChanges] = useState(false);
  const [currentStep, setCurrentStep] = useState(null);
  const [stepsStatus, setStepsStatus] = useState({});
  const [isSyncing, setIsSyncing] = useState(false);
  const [isValidating, setIsValidating] = useState(false);
  const [familleCode, setFamilleCode] = useState('');

  const { rapportTitle, applySyncResult, validateRapport, showValidateButton } = useRapportMeta(
    mission.id,
  );

  // Étapes spécifiques au levage
  const steps = [
    { key: 'etape_1_infos_generales_levage', label: 'Informations générales', icon: '📋', component: Etape1InfosLevageMobile },
    { key: 'etape_2_caracteristiques_techniques_levage', label: 'Caractéristiques techniques', icon: '⚙️', component: Etape2CaracteristiquesMobile },
    { key: 'etape_3_photos_machine_levage', label: 'Photos machine', icon: '📸', component: Etape3PhotosMachineMobile },
    { key: 'etape_4_points_controle_levage', label: 'Points de contrôle', icon: '✅', component: Etape4PointsControleMobile },
    { key: 'etape_5_documentation_essais_levage', label: 'Documentation & Essais', icon: '📄', component: Etape5DocumentationEssaisMobile },
    { key: 'etape_11_observations', label: 'Observations', icon: '⚠️', component: Etape5ObservationsLevageMobile },
    { key: 'etape_13_finalisation', label: 'Finalisation', icon: '✍️', component: Etape6FinalisationLevageMobile }
  ];

  useEffect(() => {
    loadProgress();
    checkUnsyncedChanges();
    loadStepsStatus();
    loadFamilleCode();
  }, [mission.id]);

  const loadFamilleCode = async () => {
    const etape1Data = await inspectionStorage.getStep(mission.id, 'etape_1_infos_generales_levage');
    if (etape1Data?.famille_machine_code) {
      setFamilleCode(etape1Data.famille_machine_code);
    }
  };

  const loadProgress = async () => {
    const allSteps = await inspectionStorage.getAllSteps(mission.id);
    const relevantKeys = steps.map(s => s.key);
    const completedSteps = Object.keys(allSteps).filter(k => relevantKeys.includes(k)).length;

    setProgress({
      completed: completedSteps,
      total: steps.length,
      percentage: Math.round((completedSteps / steps.length) * 100)
    });
  };

  const checkUnsyncedChanges = async () => {
    const synced = await inspectionStorage.isSynced(mission.id);
    setUnsyncedChanges(!synced);
  };

  const loadStepsStatus = async () => {
    const status = {};
    for (const step of steps) {
      const stepData = await inspectionStorage.getStep(mission.id, step.key);
      status[step.key] = stepData ? 'completed' : 'pending';
    }
    setStepsStatus(status);
  };

  const handleStepClick = (step) => {
    if (step.component) {
      setCurrentStep(step);
    } else {
      alert(`🚧 Formulaire "${step.label}" en cours de développement`);
    }
  };

  const handleBackFromStep = async () => {
    setCurrentStep(null);
    await loadProgress();
    await loadStepsStatus();
    await checkUnsyncedChanges();
    await loadFamilleCode();
  };

  const handleStepSave = async (data) => {
    console.log('✅ Étape levage sauvegardée:', data);
    await loadProgress();
    await loadStepsStatus();
    await checkUnsyncedChanges();
    await loadFamilleCode();
  };

  const handleSync = async () => {
    try {
      console.log('🔍 ========================================');
      console.log('🔍 INSPECTIONHUBLEVAGE - SYNC');
      console.log('🔍 ========================================');
      
      // ✅ CORRECTION : Utiliser cloneManager
      const token = cloneManager.getToken();
      const clone = cloneManager.getClone();
      
      console.log('🔍 Token présent:', !!token);
      console.log('🔍 Clone:', clone);
      console.log('🔍 API URL:', clone?.api_url);
      
      if (!token) {
        console.error('❌ Pas de token pour synchroniser');
        alert('❌ Vous devez être connecté pour synchroniser.\n\nVeuillez vous déconnecter et vous reconnecter.');
        return;
      }

      console.log('✅ Token trouvé, début de la sync...');
      setIsSyncing(true);

      // Récupérer toutes les données
      const allStoredData = await inspectionStorage.getAllSteps(mission.id);
      
      console.log('🔍 Clés stockées:', Object.keys(allStoredData));
      
      const allData = {};
      for (const [key, value] of Object.entries(allStoredData)) {
        if (key !== 'meta' && key !== 'sync_status' && !key.includes('synced_at')) {
          allData[key] = value;
        }
      }

      console.log('📤 Données à synchroniser:', Object.keys(allData));

      if (Object.keys(allData).length === 0) {
        alert('ℹ️ Aucune donnée à synchroniser');
        setIsSyncing(false);
        return;
      }

      console.log('📤 Envoi des données levage...', Object.keys(allData));

      // ✅ Utiliser apiService au lieu de fetch direct
      const result = await apiService.syncMissionData(mission.id, allData);

      if (result.success) {
        await inspectionStorage.markAsSynced(mission.id);
        await applySyncResult(result);
        setUnsyncedChanges(false);
        alert('✅ Synchronisation réussie !');
      } else {
        alert('❌ Erreur: ' + (result.error || 'Erreur inconnue'));
      }

    } catch (error) {
      console.error('❌ ========================================');
      console.error('❌ ERREUR SYNC LEVAGE');
      console.error('❌ ========================================');
      console.error('❌ Erreur:', error);
      console.error('❌ Message:', error.message);
      alert('❌ Erreur de synchronisation: ' + error.message);
    } finally {
      setIsSyncing(false);
    }
  };

  const handleValidateRapport = async () => {
    setIsValidating(true);
    try {
      const r = await validateRapport();
      if (r?.success && !r.alreadyValid) {
        alert('✅ Rapport validé. Numéro chrono enregistré.');
      }
    } finally {
      setIsValidating(false);
    }
  };

  // Afficher le composant de l'étape si ouverte
  if (currentStep && currentStep.component) {
    const StepComponent = currentStep.component;
    return (
      <StepComponent
        mission={mission}
        onBack={handleBackFromStep}
        onSave={handleStepSave}
        familleCode={familleCode}
      />
    );
  }

  return (
    <div className="inspection-hub">
      {/* Indicateur de synchronisation */}
      {isSyncing && (
        <div style={{
          position: 'fixed',
          top: '20px',
          right: '20px',
          background: '#10b981',
          color: 'white',
          padding: '12px 20px',
          borderRadius: '12px',
          boxShadow: '0 4px 12px rgba(0,0,0,0.2)',
          zIndex: 9999,
          display: 'flex',
          alignItems: 'center',
          gap: '12px',
          fontSize: '14px',
          fontWeight: '600'
        }}>
          <div style={{
            width: '20px',
            height: '20px',
            border: '3px solid white',
            borderTopColor: 'transparent',
            borderRadius: '50%',
            animation: 'spin 1s linear infinite'
          }}></div>
          <span>Synchronisation en cours...</span>
        </div>
      )}

      {/* Header */}
      <div className="inspection-header inspection-header--inverse" style={{ background: 'linear-gradient(135deg, #f59e0b, #d97706)' }}>
        <button type="button" className="back-button" onClick={onBack}>
          ← Retour
        </button>
        <h1>🏗️ Levage</h1>
        {typeof onGoHome === 'function' ? (
          <button type="button" className="home-nav-button" onClick={onGoHome}>
            Accueil
          </button>
        ) : (
          <div />
        )}
      </div>

      {/* Mission Info */}
      <div className="mission-info-card">
        <div className="mission-info-header">
          <h2>{rapportTitle}</h2>
          {unsyncedChanges && (
            <span className="unsynced-badge">
              🔄 Non synchronisé
            </span>
          )}
        </div>
        <p className="mission-client">{mission.client_nom}</p>
        <p className="mission-address">{mission.site_adresse}</p>
        
        {/* Badge famille machine */}
        <div style={{ display: 'flex', gap: '8px', marginTop: '12px', flexWrap: 'wrap' }}>
          <span style={{ 
            padding: '6px 12px', 
            background: 'linear-gradient(135deg, #f59e0b, #d97706)', 
            color: 'white', 
            borderRadius: '12px', 
            fontSize: '11px', 
            fontWeight: 600 
          }}>
            🏗️ Vérification Levage
          </span>
          {familleCode && (
            <span style={{ 
              padding: '6px 12px', 
              background: '#fef3c7', 
              color: '#92400e', 
              borderRadius: '12px', 
              fontSize: '11px', 
              fontWeight: 600 
            }}>
              Annexe {familleCode}
            </span>
          )}
        </div>
      </div>

      {/* Progress */}
      <div className="progress-card">
        <div className="progress-header">
          <span className="progress-label">Progression</span>
          <span className="progress-value">
            {progress.completed}/{steps.length} ({progress.percentage}%)
          </span>
        </div>
        <div className="progress-bar">
          <div 
            className="progress-fill" 
            style={{ 
              width: `${progress.percentage}%`,
              background: 'linear-gradient(135deg, #f59e0b, #d97706)'
            }}
          ></div>
        </div>
      </div>

      {/* Steps List */}
      <div className="steps-container">
        <h3 className="steps-title">Étapes de vérification levage</h3>
        
        <div className="steps-list">
          {steps.map((step, index) => {
            const status = stepsStatus[step.key] || 'pending';

            return (
              <div
                key={step.key}
                className={`step-item ${status}`}
                onClick={() => handleStepClick(step)}
              >
                <div className="step-number" style={{ 
                  background: status === 'completed' ? '#f59e0b' : '#e5e7eb' 
                }}>{index + 1}</div>
                <div className="step-icon">{step.icon}</div>
                <div className="step-content">
                  <div className="step-label">{step.label}</div>
                  <div className="step-key">{step.key}</div>
                </div>
                <div className="step-status">
                  {status === 'completed' ? '✅' : '⬜'}
                </div>
              </div>
            );
          })}
        </div>
      </div>

      {/* Actions */}
      <div className="inspection-actions">
        <button className="action-button secondary" onClick={() => alert('💾 Données sauvegardées localement')}>
          💾 Sauvegarder localement
        </button>
        {showValidateButton && (
          <button
            type="button"
            className="action-button primary"
            style={{ background: 'linear-gradient(135deg, #059669, #047857)' }}
            onClick={handleValidateRapport}
            disabled={isValidating || !navigator.onLine}
          >
            {isValidating ? '⏳ Validation…' : '✅ Valider le rapport (chrono)'}
          </button>
        )}
        <button 
          className="action-button primary" 
          onClick={handleSync}
          disabled={isSyncing}
          style={{ background: 'linear-gradient(135deg, #f59e0b, #d97706)' }}
        >
          {isSyncing ? '⏳ Synchronisation...' : '🔄 Synchroniser'}
        </button>
      </div>

      {/* Info */}
      <div className="inspection-info">
        <p>🏗️ Vérification d'appareil de levage selon Arrêté du 1er mars 2004</p>
      </div>
    </div>
  );
}

export default InspectionHubLevage;